export default __webpack_public_path__ + "static/realWorldImg2-4c08babd32c7e3a24069c5a448ee8e5c.webp";